import axios from 'axios';

export const FETCH_ESB_REFERENCE_DATA_BEGIN = 'FETCH_ESB_REFERENCE_DATA_BEGIN';
export const FETCH_ESB_REFERENCE_DATA_SUCCESS = 'FETCH_ESB_REFERENCE_DATA_SUCCESS';
export const FETCH_ESB_REFERENCE_DATA_FAILURE = 'FETCH_ESB_REFERENCE_DATA_FAILURE';

export const fetchEsbReferenceDataBegin = () => ({
    type: FETCH_ESB_REFERENCE_DATA_BEGIN
});

export const fetchEsbReferenceDataSuccess = (value) => ({
    type: FETCH_ESB_REFERENCE_DATA_SUCCESS,
    payload: value
});

export const fetchEsbReferenceDataFailure = (error) => ({
    type: FETCH_ESB_REFERENCE_DATA_FAILURE,
    payload: error
});

export const fetchEsbReferenceData = (webappurlForms, accessToken) => {
    return dispatch => {
        const options = {
            headers: {
                'Authorization': "Bearer " + accessToken,
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        dispatch(fetchEsbReferenceDataBegin());
        return axios.post(webappurlForms + "/api/myCASA/Forms/getMplReferenceDataFromESB/v1", null, options)
            .then(response => {
                if (response.data.wasSuccessful && response.data?.referenceData.length > 0) {
                    let validCategories = ["B1.1", "B1.2", "B1.3", "B1.4", "B2"];
                    let categoryRemovalOptions = [];
    
                    response.data.referenceData.forEach(refData => {
                        if (refData?.additionalFieldsSerialized) {
                            let additionalData = refData.additionalFieldsSerialized
                            if (validCategories.indexOf(additionalData.name) >= 0 && additionalData.limitations.length > 0) {
                                let option = {};
                                option.name = additionalData.name;
                                option.value = additionalData.name;
                                option.label = additionalData.name;
    
                                let limitations = [];
                                additionalData.limitations.forEach(limitation => {
                                    let limitationObject = {};
                                    limitationObject.name = limitation.type;
                                    limitationObject.value = limitation.type;
                                    limitationObject.label = limitation.type + " - " + limitation.name;
                                    limitations.push(limitationObject);
                                })
    
                                option.options = limitations.sort((a, b) => a.value.localeCompare(b.value, 'en', { numeric: true }));
                                categoryRemovalOptions.push(option);
                            }
                        }
                    })
                    if (categoryRemovalOptions.length){
    
                        categoryRemovalOptions = categoryRemovalOptions.sort((a, b) => {
                            return a.value > b.value ? 1 : -1;
                        })
                        return dispatch(fetchEsbReferenceDataSuccess(categoryRemovalOptions));
                    } else {
                        return dispatch(fetchEsbReferenceDataFailure("Unable to fetch Limitations reference data"));
                    }
                } else {
                    return dispatch(fetchEsbReferenceDataFailure(response.errors));
                }
            })
            .catch(error => {
                return dispatch(fetchEsbReferenceDataFailure(error.response ? error.response.data.errors : error));
            });
    };
}


